import { render, staticRenderFns } from "./IconPen.vue?vue&type=template&id=f77befd0&functional=true&"
import script from "./IconPen.vue?vue&type=script&lang=js&"
export * from "./IconPen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports